import React from 'react';
import './Footer.css';


const Footer = () => {
    return (
        <div className="footer py-5">
            <p>Designed & Built by Aulad Hossen &copy; 2021</p>
        </div>
    );
};

export default Footer;